export default __webpack_public_path__ + "static/python-2d3e585e4e0d713f16e0df38c902119d.png";